const defaultIncrements = ['5', '10', '50'];

const customIncrements = {
    DKK: ['50', '100', '500'],
    RON: ['10', '50', '100'],
    SEK: ['50', '100', '500'],
};

const getIncrementKeys = currencyIso => customIncrements[currencyIso] || defaultIncrements;

export default getIncrementKeys;
